import styled from "styled-components/macro";

export const CfcGridBanner = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 4px 12px;
  display: flex;
  align-items: center;
  gap: 32px;
  background: ${({ theme }) => theme.blueDark};
  color: ${({ theme }) => theme.white};
  border-radius: 8px 8px 0 0;
`;

export const CfcGridBannerMessage = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  font-size: 16px;
  line-height: 22px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CfcGridBannerStrong = styled.span`
  font-family: bold;
`;

export const CfcGridBannerActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const CfcGridBannerOrderButton = styled.button`
  height: 30px;
  padding: 0 15px;
  border-radius: 15px;
  border: 2px solid ${({ theme }) => theme.white};
  background: transparent;
  color: ${({ theme }) => theme.white};
  cursor: pointer;
  font-size: 12px;
  font-family: bold;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
  }
`;
